@if (!hasCertificate()) {
<fuse-alert
    class="block m-2"
    [type]="blocking ? 'error' : 'warning'"
    [appearance]="'outline'"
    *transloco="let t; prefix: 'digital-certificate'"
>
    <div class="flex flex-wrap items-center justify-between gap-2 p-2">
        <div class="flex flex-col gap-1">
            <span class="fuse-alert-title">{{ t(blocking ? "notice-title-blocking" : "notice-title") }}</span>

            <span class="flex-1">{{ t(blocking ? "notice-description-blocking" : "notice-description") }}</span>
        </div>

        <button mat-button (click)="registerCertificate()">
            {{ t("notice-cta") }}
        </button>
    </div>
</fuse-alert>
}
